export const formatBoolean = value => (value ? 'Yes' : 'No');
